import { ReactNode, useRef } from "react";
import { createPortal } from "react-dom";

import useOnClickOutside from "@/hooks/ui/useClickOutside";

import { twMerge } from "tailwind-merge";

type Props = {
  isOpen: boolean;
  children: ReactNode;
  containerClassname?: string;
  shouldCloseModalOnClickOutside?: boolean;
  onClose: () => void;
};

const Modal = ({
  isOpen,
  children,
  containerClassname,
  shouldCloseModalOnClickOutside = true,
  onClose
}: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  useOnClickOutside(ref, onClose, [], shouldCloseModalOnClickOutside);

  const rootElement = document.getElementById("overlays");
  if (!isOpen || !rootElement) return null;

  return createPortal(
    <div className="modal" data-testid="modal">
      <div className={twMerge("modal-content", containerClassname)} ref={ref}>
        {children}
      </div>
    </div>,
    rootElement
  );
};

export default Modal;
